"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/back-top/style/index.js
// module id = 1166
// module chunks = 1